<template>
    <modal :title="title" :id="id" :actionButtons="false" :closeButton="true" @shown="shown() ">
        <template slot="modal-header">
            <div></div>
        </template>

        <div class="row align-items-center mb-2">
            <div class="col-auto">
                <button class="btn btn-white">{{$t('Agreement')}}</button>
            </div>
            <div class="col-auto">
                <button class="btn btn-white">{{$t('Client application')}}</button>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'


export default {
    name: 'print-options',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
    },
    data() {
        return {
            title: 'Print options',
        }
    },
    computed: {

    },
    mounted() {


    },

    methods: {

        shown() {
        },


    },

}
</script>
<style>
</style>
